<template>
  <ul>
    <li>
      <div v-if="nudges.includes('address-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'address-form' }">Address(es) and Phone(s)</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('disability-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'disability-form' }">Disability Status</router-link>
    </li>
    <li><a :href="emergencyURL">Emergency Contacts</a></li>
    <li>
      <div v-if="nudges.includes('external-email-form')" class="nudge"><span class="sr-only">Please review: </span>
      </div>
      <router-link :to="{ name: 'external-email-form' }">External Email</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('sogi-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'sogi-form' }">Gender, Pronouns, and Sexual Orientation</router-link>
      <ul v-if="isAdmin">
        <li v-if="isAdmin && canProxy"><router-link :to="{ name: 'sogi-admin' }">Edit Data for Others</router-link></li>
        <li v-if="isAdmin"><router-link :to="{ name: 'so-options' }">Edit Sexual Orientation Options</router-link></li>
        <li v-if="isAdmin"><router-link :to="{ name: 'gi-options' }">Edit Gender Identity Options</router-link></li>
      </ul>
    </li>
    <li>
      <div v-if="nudges.includes('legal-sex-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'legal-sex-form' }">Legal Sex</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('parent-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'parent-form' }">Parent/Guardian Status</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('preferred-name-form')" class="nudge"><span class="sr-only">Please review: </span>
      </div>
      <router-link :to="{ name: 'preferred-name-form' }">Preferred Name</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('race-ethnicity-form')" class="nudge"><span class="sr-only">Please review: </span>
      </div>
      <router-link :to="{ name: 'race-ethnicity-form' }">Race and Ethnicity</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('tribal-affiliation-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'tribal-affiliation-form' }">Tribal Affiliation</router-link>
    </li>
    <li>
      <div v-if="nudges.includes('veteran-form')" class="nudge"><span class="sr-only">Please review: </span></div>
      <router-link :to="{ name: 'veteran-form' }">Veteran Classification</router-link>
    </li>
  </ul>
</template>

<script>

import { emergencyURL } from '@/utils.js'
import _ from "lodash"

export default {
  name: 'NavLinks',

  props: {
    nudges: Array
  },

  computed: {
    isAdmin() {
      var jwt = this.$jwt.read(this.$appName)
      return jwt && jwt.app_roles && jwt.app_roles.indexOf("admin") >= 0
    },

    canProxy() {
      var jwt = this.$jwt.read(this.$appName)
      return jwt && jwt.app_roles && _.intersection(jwt.app_roles, this.$proxyRoles).length >= 0
    },

    isStudent() {
      var jwt = this.$jwt.read(this.$appName)
      return jwt && jwt.roles && jwt.roles.split(":").indexOf("STUDENT") >= 0
    },

    emergencyURL() {
      return emergencyURL()
    },
  },
}
</script>

<style scoped>

</style>
